export default function TrustSection() {
  const features = [
    {
      icon: 'ri-price-tag-3-line',
      title: 'Negotiated & Consolidator Fares',
      description: 'Access exclusive airline rates not available on public booking sites',
    },
    {
      icon: 'ri-group-line',
      title: 'Special Family Discounts',
      description: 'Save more when booking for families and groups traveling together',
    },
    {
      icon: 'ri-team-line',
      title: 'Group & Umrah Packages',
      description: 'Specialized group fares for Umrah, Hajj, and religious travel',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Flexible Date Options',
      description: 'Find the best fares with flexible travel date alternatives',
    },
    {
      icon: 'ri-route-line',
      title: 'Multi-City & Complex Routes',
      description: 'Expert handling of complex itineraries and multi-destination trips',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 WhatsApp Support',
      description: 'Instant assistance and booking support via WhatsApp anytime',
    },
    {
      icon: 'ri-map-pin-user-line',
      title: 'UK-Based Travel Experts',
      description: 'Local London-based team with deep industry connections',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'ATOL Protected',
      description: 'Your bookings are financially protected and secure',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Why Book Flights With Alwaz Travels?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We leverage our industry relationships and bulk buying power to secure the best airfares for our clients
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#14B8A6]/30"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-[#14B8A6] to-[#0F9688] rounded-lg flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#14B8A6] to-[#0F9688] rounded-2xl p-8 text-center">
          <div className="flex flex-wrap justify-center items-center gap-12">
            <div className="text-white">
              <div className="text-4xl font-bold mb-2">15+</div>
              <div className="text-sm opacity-90">Years Experience</div>
            </div>
            <div className="text-white">
              <div className="text-4xl font-bold mb-2">50K+</div>
              <div className="text-sm opacity-90">Happy Travelers</div>
            </div>
            <div className="text-white">
              <div className="text-4xl font-bold mb-2">100+</div>
              <div className="text-sm opacity-90">Airlines Partners</div>
            </div>
            <div className="text-white">
              <div className="text-4xl font-bold mb-2">200+</div>
              <div className="text-sm opacity-90">Destinations</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
